/** Figma 5074-12188 frame — fixed chrome heights (px). */
export const AUTH_TOP_BAR_HEIGHT_PX = 64
/** Figma 5074-11764 — inner footer content band */
export const AUTH_FOOTER_HEIGHT_PX = 68
/** Figma 5074-12192 — footer frame including top border row */
export const AUTH_FOOTER_OUTER_HEIGHT_PX = 69
export const AUTH_CHROME_HEIGHT_PX = AUTH_TOP_BAR_HEIGHT_PX + AUTH_FOOTER_OUTER_HEIGHT_PX

/** Main content band between header and footer — no page scroll. */
export const AUTH_MAIN_HEIGHT = `calc(100dvh - ${AUTH_CHROME_HEIGHT_PX}px)`

/** Figma 5074-11767 / 5074-12188 — left column is 640px of 1280px frame (= 50%). */
export const LOGIN_MARKETING_PANEL_BASIS = '50%'
/** Figma 5074-11768 — inner content column */
export const LOGIN_MARKETING_CONTENT_MAX_WIDTH_PX = 480
/** Figma 5074-11767 reference frame (handoff at 1280×1024) */
export const LOGIN_MARKETING_PANEL_REF_WIDTH_PX = 640
export const LOGIN_MARKETING_PANEL_REF_HEIGHT_PX = 890

/** Figma 5074-11768 — inset inside 5074-11767 (640×890) */
export const LOGIN_MARKETING_PADDING_LEFT_PX = 100
export const LOGIN_MARKETING_PADDING_RIGHT_PX = 60
/** Figma 5074-11768 — top inset inside 5074-11767; bottom matches for symmetric band (ld-115). */
export const LOGIN_MARKETING_PADDING_TOP_PX = 80
export const LOGIN_MARKETING_PADDING_BOTTOM_PX = LOGIN_MARKETING_PADDING_TOP_PX

/** Proportional insets — keep alignment when panel ≠ 640px */
export const LOGIN_MARKETING_PADDING_LEFT_RATIO =
  LOGIN_MARKETING_PADDING_LEFT_PX / LOGIN_MARKETING_PANEL_REF_WIDTH_PX
export const LOGIN_MARKETING_PADDING_RIGHT_RATIO =
  LOGIN_MARKETING_PADDING_RIGHT_PX / LOGIN_MARKETING_PANEL_REF_WIDTH_PX
export const LOGIN_MARKETING_PADDING_TOP_RATIO =
  LOGIN_MARKETING_PADDING_TOP_PX / LOGIN_MARKETING_PANEL_REF_HEIGHT_PX
export const LOGIN_MARKETING_PADDING_BOTTOM_RATIO =
  LOGIN_MARKETING_PADDING_BOTTOM_PX / LOGIN_MARKETING_PANEL_REF_HEIGHT_PX

/** Figma 5074-11769 — illustration row (contains 5074-11770 art + bottom inset) */
export const LOGIN_ILLUSTRATION_WRAPPER_WIDTH_PX = 350
export const LOGIN_ILLUSTRATION_WRAPPER_HEIGHT_PX = 372.96875

/** Figma node 5074:11770 — illustration frame */
export const LOGIN_ILLUSTRATION_WIDTH_PX = 333
export const LOGIN_ILLUSTRATION_HEIGHT_PX = 347

/** 5074-11769 / 5074-11768 — illustration row vs content column */
export const LOGIN_ILLUSTRATION_WRAP_WIDTH_RATIO =
  LOGIN_ILLUSTRATION_WRAPPER_WIDTH_PX / LOGIN_MARKETING_CONTENT_MAX_WIDTH_PX
/** 5074-11770 inside 5074-11769 */
export const LOGIN_ILLUSTRATION_ART_WIDTH_RATIO =
  LOGIN_ILLUSTRATION_WIDTH_PX / LOGIN_ILLUSTRATION_WRAPPER_WIDTH_PX
export const LOGIN_ILLUSTRATION_ART_HEIGHT_RATIO =
  LOGIN_ILLUSTRATION_HEIGHT_PX / LOGIN_ILLUSTRATION_WRAPPER_HEIGHT_PX
/** Scales 5074-11769 with 5074-11768 content column (480px ref) */
export const LOGIN_ILLUSTRATION_WRAP_WIDTH_CQW =
  (LOGIN_ILLUSTRATION_WRAPPER_WIDTH_PX / LOGIN_MARKETING_CONTENT_MAX_WIDTH_PX) * 100

/** Figma 5074-11914 — reference height at 72px/line (not a layout minHeight) */
export const LOGIN_MARKETING_HEADLINE_BLOCK_HEIGHT_PX = 288
export const LOGIN_MARKETING_HEADLINE_LINE_HEIGHT_PX = 72

/** Figma 5074-11769 → 5074-11913 (flush); +24px look-and-feel */
export const LOGIN_MARKETING_ILLUSTRATION_TO_COPY_GAP_PX = 24
/** Figma 5074-11916 → 5074-11918 (flush); +8px */
export const LOGIN_MARKETING_TURN_TO_SIGNALS_GAP_PX = 8
/** Figma 5074-11918 → 5074-11919 (~1.5px); +8px */
export const LOGIN_MARKETING_SIGNALS_TO_STRATEGIC_GAP_PX = 8
/** Figma 5074-11914 → 5074-11922 (16px); +8px look-and-feel */
export const LOGIN_MARKETING_HEADLINE_SUBTITLE_GAP_PX = 24

export const LOGIN_MARKETING_SUBTITLE_MAX_WIDTH_PX = 448

/** @deprecated Use LOGIN_MARKETING_PANEL_BASIS — design reference width only */
export const LOGIN_MARKETING_WIDTH_PX = 640
export const LOGIN_FORM_WIDTH_PX = 400
